import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { DocsService } from '../../../services/docs.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-new-doc',
  templateUrl: './new-doc.component.html',
  styleUrls: ['./new-doc.component.scss']
})
export class NewDocComponent {

  doc = {
    title: '',
    body: ''
  };

  constructor(private graphqlService: DocsService, private router: Router, public snackBar: MatSnackBar) {  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {duration: 3000});
  }

  addDoc() {
    this.graphqlService.create(this.doc).subscribe(res => {
      if (res.data && res.data.createDocument.success) {
        this.openSnackBar('Doc Created', '');
        this.router.navigate(['/docs']);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/docs/new-doc/new-doc.component.ts